// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"f8d17807","846":"72a8f893"}[chunkId] + ".chunk.css";
};